<template>
  <div>
    <transition name="fade" appear mode="out-in">
      <div id="welcome" v-if="step === 1" key="welcome">
        <div class="container">
          <div class="row">
            <div class="col-md-4 offset-md-4">
              <div class="py-4 text-center">
                <h1>Life In Weeks</h1>
                <form class="needs-validation mt-5" novalidate @submit.prevent="next" ref="form">
                  <div class="form-group">
                    <label for="dateOfBirth">Date of birth</label>
                    <cleave
                      v-model="dateOfBirth"
                      :options="cleaveOptions"
                      :raw="false"
                      class="form-control"
                      name="dateOfBirth"
                      placeholder="dd-mm-yyyy"
                      required
                    ></cleave>
                  </div>
                  <div class="form-group">
                    <label for="gender">Gender</label>
                    <select required class="custom-select" v-model="gender">
                      <option disabled value>Please select</option>
                      <option>Male</option>
                      <option>Female</option>
                    </select>
                  </div>
                  <div class="form-group">
                    <label for="location">Where are you from?</label>
                    <select required class="custom-select" v-model="location">
                      <option disabled value>Please select</option>
                      <option
                        v-for="country in countries"
                        v-bind:value="country"
                        :key="country"
                      >{{ country }}</option>
                    </select>
                  </div>
                  <div class="form-group">
                    <small class="form-text text-muted">
                      Life expectancy calculated using data from
                      <a
                        target="_blank"
                        href="https://esa.un.org/unpd/wpp/Publications/Files/WPP2015_Volume-I_Comprehensive-Tables.pdf"
                      >UN - World Population Prospects 2015</a>
                    </small>
                    <small class="form-text text-muted">
                      Inspired by
                      <a
                        target="_blank"
                        href="https://waitbutwhy.com/2014/05/life-weeks.html"
                      >Tim Urban</a>
                    </small>
                  </div>
                  <button type="submit" class="btn btn-light btn-lg mt-3">Calculate</button>
                </form>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-md-12">
              <footer class="my-5 pt-5 text-muted text-center text-small">
                <small class="mb-1">
                  Made by
                  <a href="https://www.matt-darby.co.uk/" target="_blank">Matt Darby</a>
                </small>
              </footer>
            </div>
          </div>
        </div>
      </div>
      <div id="calendar" v-else key="calendar">
        <table>
          <tr class="year" v-for="(year, yearIndex) in totalYears" :key="year.id">
            <td
              class="week"
              v-for="(week, weekIndex) in 52"
              :key="week.id"
              v-bind:class="{ lived: (((yearIndex) * 52) + weekIndex+1) <= weeksLived }"
            ></td>
          </tr>
        </table>
      </div>
    </transition>
  </div>
</template>

<script>
import lifeExpectancyData from "../assets/life-expectancy.json";
import Cleave from "vue-cleave-component";
import moment from "moment";

export default {
  name: "Welcome",
  data() {
    return {
      gender: "",
      location: "",
      dateOfBirth: null,
      step: 1,
      cleaveOptions: {
        date: true,
        datePattern: ["d", "m", "Y"],
        delimiter: "-"
      }
    };
  },
  methods: {
    next() {
      if (this.$refs.form.checkValidity() === false) {
        event.preventDefault();
        event.stopPropagation();
        this.$refs.form.classList.add("was-validated");
      } else {
        this.step++;
      }
    }
  },
  computed: {
    countries() {
      var countries = [];
      lifeExpectancyData.fact.forEach(function(entry) {
        countries.push(entry.dims.COUNTRY);
      });
      return (countries = [...new Set(countries)]);
    },
    lifeExpectancy() {
      if (this.gender != "" && this.location != "") {
        return lifeExpectancyData.fact.find(
          entry =>
            entry.dims.COUNTRY === this.location &&
            entry.dims.SEX === this.gender
        ).Value;
      }
    },
    dateOfBirthMoment() {
      return moment(this.dateOfBirth, "DD-MM-YYYY");
    },
    totalYears() {
      if (this.lifeExpectancy != null && this.dateOfBirth != null) {
        var s = moment(this.dateOfBirthMoment).add(
          this.lifeExpectancy,
          "years"
        );
        return s.diff(this.dateOfBirthMoment, "years");
      }
    },
    weeksLived() {
      if (this.dateOfBirth != null) {
        return moment().diff(this.dateOfBirthMoment, "weeks");
      }
    }
  },
  components: {
    Cleave
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
#calendar {
  padding: 2vw;
  width: 100vw;
  height: 100vh;
}
#calendar table {
  width: 100%;
  height: 100%;
  padding: 50px;
  margin: 0 auto;
  border-collapse: collapse;
}
.week {
  border: 0.2vw solid #fff;
  background: #e6e6e6;
}

.week.lived {
  background: #999;
}
.fade-enter-active,
.fade-leave-active {
  transition: opacity 1s;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}
</style>
